import React from 'react';
import './PaymentFailureSection.css';

interface PaymentFailureSectionProps {
  className?: string;
}

const PaymentFailureSection: React.FC<PaymentFailureSectionProps> = ({ className = '' }) => {
  return (
    <div className={`payment-failure-section ${className}`}>
      <div className="payment-failure-container">
        <div className="payment-failure-card">

          {/* Main Content */}
          <div className="payment-failure-content">
            <h1 className="payment-failure-title">
              Oops! Something Went Wrong with<br />
              Your Payment
            </h1>

            <p className="payment-failure-description">
              Unfortunately, your payment didn't go through. But<br />
              don't worry — here are a few things you can try:
            </p>

            <div className="payment-failure-instructions">
              <div className="instruction-item">
                <span className="bullet">•</span>
                <span className="instruction-text">
                  <strong>Double-check</strong> your payment details to ensure<br />
                  everything is correct.
                </span>
              </div>

              <div className="instruction-item">
                <span className="bullet">•</span>
                <span className="instruction-text">
                  <strong>Try a different payment method</strong> if available.
                </span>
              </div>

              <div className="instruction-item">
                <span className="bullet">•</span>
                <span className="instruction-text">
                  <strong>Wait a moment and try again</strong>, especially if<br />
                  you're experiencing connectivity issues.
                </span>
              </div>

              <div className="instruction-item">
                <span className="bullet">•</span>
                <span className="instruction-text">
                  For concerns regarding payment details and<br />
                  your credit card bill, please get in touch with<br />
                  your credit card company.
                </span>
              </div>
            </div>

            <p className="payment-failure-contact">
              If you need help or have any questions, please email us at{' '}
              <a href="mailto:traveldirect_team@pacificcross.com.ph" className="email-link">
                traveldirect_team@pacificcross.com.ph
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailureSection;